/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusObjektListResponseDto } from '../../models/lexplus-objekt-list-response-dto';

export interface ObjekteControllerFindAllPaginatedV1$Params {

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by objektkategorieID query param.
 *
 * **Format:** filter.objektkategorieID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.objektkategorieID=$eq:John Doe&filter.objektkategorieID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.objektkategorieID'?: Array<string>;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=objektID:DESC&sortBy=status:DESC
 *
 *
 * **Default Value:** objektID:ASC
 *
 * **Available Fields**
 * - objektID
 *
 * - status
 *
 * - name
 *
 * - kategorieName
 */
  sortBy?: Array<'objektID:ASC' | 'objektID:DESC' | 'status:ASC' | 'status:DESC' | 'name:ASC' | 'name:DESC' | 'kategorieName:ASC' | 'kategorieName:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** objektID,objektkategorieID,status,uebersetzung
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function objekteControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: ObjekteControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusObjektListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.objektkategorieID', params['filter.objektkategorieID'], {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusObjektListResponseDto>;
    })
  );
}

objekteControllerFindAllPaginatedV1.PATH = '/v1/objekte/paginated';
